import React from 'react';
import Modal from 'react-modal';
import { CloseBtn } from './UI/Modal';
import { Typography, Box } from '@material-ui/core';

const NotificationModal = ({ open, onClose = () => {}, title, message, bottomBtns, withoutCloseBtn = false }) => {
    return (
        <Modal
            isOpen={open}
            onClose={onClose}
            onRequestClose={onClose}
            className="Modal notification-modal"
            overlayClassName="Overlay"
            ariaHideApp={false}
        >
            {!withoutCloseBtn && <CloseBtn onClose={onClose} />}
            <Box mb={2}>{title && <Typography variant="h5">{title}</Typography>}</Box>

            {message && (
                <Box mb={5}>
                    <Typography variant="h6">{message}</Typography>
                </Box>
            )}

            {bottomBtns}
        </Modal>
    );
};

export default NotificationModal;
